module.exports = __webpack_public_path__ + "static/img/micss_logo_white_vert.6a574d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/micss_logo_white_vert.svg
// module id = fZI6
// module chunks = 3